import { addPermissionsToRoute } from '@/myq-core/';

const routes = [
  {
    name: 'Business Unit',
    icon: 'mdi-store-outline',
    path: '/reports/mcd/businessUnit/',
    children: [
      // quicksight for BU team
      {
        path: '/businessUnitBI',
        alias: '/home-dashboard',
        name: 'Business Unit BI',
        meta: { id: 'bu-dashboard' },
        component: () => import('@/views/mcd/businessUnit/quickSight/main.vue'),
        ...addPermissionsToRoute(['bu_quicksight_access']),
      },
      {
        path: '/businessUnitBI/customRequestForm',
        name: 'Custom Request Form',
        meta: { id: 'bu-reports' },
        component: () => import('@/views/mcd/businessUnit/quickSight/CustomRequestForm.vue'),
        ...addPermissionsToRoute(['bu_quicksight_access']),
      },
    ]
  }
];

export default routes;